export default __webpack_public_path__ + "static/media/uts.27d9b702.woff2";